interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);
  return (
    <nav aria-label="分页" className="flex items-center justify-center flex-wrap gap-2 mt-10">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="w-10 h-10 flex items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((page) => (
        <button
          key={page}
          type="button"
          onClick={() => onChange(page)}
          className={`w-10 h-10 flex items-center justify-center rounded-md text-sm font-medium transition-colors cursor-pointer ${
            page === current
              ? "bg-primary-500 text-background-50"
              : "border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
          }`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="w-10 h-10 flex items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}